import { createAsyncThunk } from "@reduxjs/toolkit";
import { _hospitalUrls } from "@custom/Utils/constants/apiUrls";

const odooApprovedApi = createAsyncThunk(
  'hospital/odooApprovedApi',
  async (
    payload: string | { hospitalId: string; isApproved: boolean },
    { rejectWithValue }
  ) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let body: { hospitalId: string; isApproved?: boolean };

      if (typeof payload === 'string') {
        body = { hospitalId: payload };
      } else {
        body = payload;
      }
      const response = await fetch(_hospitalUrls.odooApproved, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to approve hospital');
      }
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'An unexpected error occurred');
    }
  }
);


export default odooApprovedApi;
